import _ from 'lodash/fp'
import { take, put, call, takeEvery } from 'redux-saga/effects'
import { makeSaga } from './util'

import { types as guideTypes, actions as guideActions } from '../reducers/guides'

import { getEffect } from './network'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * getShotsForGuideEffect ({ guideId }) {
  const request = {
    url: 'stats/shots/' + guideId
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * getShotsForGuideFlow ({ payload }) {
  const data = yield call(getShotsForGuideEffect, payload)
  const shots = _.flow(
    _.get('shots'),
    _.groupBy('holeId'),
    _.mapValues(_.groupBy('gameId')),
    _.mapValues(_.mapValues(_.keyBy('shotId')))
  )(data)
  yield put(guideActions.finishedShotsForGuide({ guideId: payload.guideId, shots }))
}

export default makeSaga([
  takeEvery(guideTypes.REQUEST_SHOTS_FOR_GUIDE, getShotsForGuideFlow)
])
